import React from 'react';
import { motion } from 'framer-motion';
import './InfoBannerSection.css';

const InfoBannerSection = ({
  logo,
  logoAlt = '',
  title,
  subtitle,
  description,
  buttonText,
  buttonLink = '#',
  image,
  imageAlt = '',
  rightContent,
  className = '',
  glowImage,
  glowAlt = 'Glowing Background',
  imageOverflow = false,
}) => (
  <section className={`partner-section  ${className}`}>
    <div className=" partner-container container">
      <motion.div
        className="partner-left"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="partner-logo-row">
          {logo && <img src={logo} alt={logoAlt} className="partner-logo" />}
          {title && <span className="partner-title">{title}</span>}
        </div>
        {subtitle && <h2 className="partner-heading">{subtitle}</h2>}
        {description && <p className="partner-desc">{description}</p>}
        {buttonText && (
          <div className="partner-btn-row">
            <a href={buttonLink} className="explore-btn">{buttonText}</a>
          </div>
        )}
      </motion.div>
      <motion.div
        className="partner-right"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
      >
        <div className={`partner-img-wrap${imageOverflow ? ' image-overflow' : ''}`}>
          {glowImage && (
            <motion.img
              src={glowImage}
              alt={glowAlt}
              className="partner-glow-img"
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 12, ease: 'linear' }}
            />
          )}
          {image && <img src={image} alt={imageAlt} className="partner-img" />}
        </div>
        {rightContent}
      </motion.div>
    </div>
  </section>
);

export default InfoBannerSection; 